import { Button } from '@shared/components/shadcn';
import { getSiteConfig } from '@shared/config';
import { twMerge } from '@shared/themes';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import type { ComponentProps } from 'react';
import { PurchasesStateIcon } from '../PurchasesStateIcon/PurchasesStateIcon';

type PurchasesEmptyStateProps = ComponentProps<'div'> & {
  'data-testid'?: string;
};

function PurchasesEmptyState({ className, 'data-testid': dataTestId = 'purchases-empty-state', ...props }: PurchasesEmptyStateProps) {
  const t = useTranslations('lotteries.purchase.empty_state');
  const { emptyStateCtaHref } = getSiteConfig().LOTTERY_PURCHASES;

  return (
    <div className={twMerge('flex flex-col items-center gap-4 px-4 py-10 text-center', className)} data-testid={dataTestId} {...props}>
      <PurchasesStateIcon />
      <p className="text-foreground-subtle max-w-75" data-testid="purchases-empty-state-message">
        {t('message')}
      </p>
      <Button asChild size="m" variant="primary" data-testid="purchases-empty-state-cta">
        <Link href={emptyStateCtaHref} data-track-name="Discover">
          {t('cta')}
        </Link>
      </Button>
    </div>
  );
}

export { PurchasesEmptyState };
